import { render, staticRenderFns } from "./DatePickerWidget.vue?vue&type=template&id=2844a41e&"
import script from "./DatePickerWidget.vue?vue&type=script&lang=js&"
export * from "./DatePickerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports